import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import classNames from "classnames";

import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import { TextRupiah } from "../../../components/Text";
import Countdown, { zeroPad } from "react-countdown";
import {
  getCollectionList,
  getImageBanner
} from "../../../actions/kafairAction";
import moment from "moment";
import { normalizeBrand } from "../../../utils/Helpers";
import { getCloudImageUrl, emptyImage } from "../../../utils";

import FanImg from "../../../images/kipas.png";
import emptySneakerImg from "../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../images/emptyhandbags.png";

const goldenTicket = require("../../../images/golden-ticket.png");
const standardTicket = require("../../../images/standard-ticket.png");

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return (
      <div>
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  } else {
    return (
      <div className="countdown-wrapper">
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  }
};

const previewSettings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  // slidesToShow: 3,
  // slidesToScroll: 3,
  lazyLoad: true,
  dots: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

class RaffleSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "sneakers",
      color: "#fff"
    };
  }

  componentDidMount() {
    this.setState({ color: this.props.color });
  }

  renderProducts = () => {
    const { category } = this.state;
    let { products, group_name } = this.props;

    const productLength = products ? products.length : 0;

    return (
      <div>
        {products && products.length > 0 ? (
          <Thumbnails
            settings={{
              ...previewSettings,
              slidesToShow: Math.min(productLength, 3)
            }}
            afterChange={this.changeImage}
            beforeChange={this._handleBeforeChange}
            thumbnails={products.map(item => {
              return {
                id: item.id,
                slug: `kafair/raffle/${group_name}`,
                img: item.image
                  ? getCloudImageUrl(item.image, 400)
                  : emptyImage(category),
                display_name: item.display_name,
                brand: item.brand && item.brand.flat[0],
                price: item.price,
                out_of_stock: item.out_of_stock,
                category
              };
            })}
            active={this.state.currentIndex}
            renderItems={products => this._renderItems(category, products)}
            lengthShow={1}
          />
        ) : null}
      </div>
    );
  };

  _renderItems(category, data) {
    const { start_date } = this.props;
    const isStart = moment().isAfter(start_date);

    return data.map((item, index) => (
      <a
        href={`${item.slug}`}
        title={item.display_name}
        key={index}
        className="sneaker-item"
      >
        <div className={classNames("product-card")}>
          <div
            className={classNames("sneaker-item__text", {
              disabled: !item.price || item.out_of_stock || !isStart
            })}
          >
            <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
            <p>{item.display_name}</p>
          </div>
          <KickImage
            alt={item.display_name}
            src={item.img}
            className={classNames("sneaker-item__image", {
              disabled: !item.price || item.out_of_stock || !isStart
            })}
          />
          {item.price ? (
            <TextRupiah
              value={item.price}
              className="price-tag"
              color="black"
              bold={true}
              align="center"
              disabled={!item.price || item.out_of_stock || !isStart}
            />
          ) : (
            <span className="text-center red">Out of stock</span>
          )}
        </div>
      </a>
    ));
  }

  renderTimer = ({ days, hours, minutes, seconds, completed }) => {
    const { name, color } = this.state;

    if (completed) {
      return (
        <div className={classNames("countdown-wrapper")}>
          <span style={{ backgroundColor: color }}>{zeroPad(days)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(hours)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(minutes)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(seconds)}</span>
        </div>
      );
    } else {
      return (
        <div className={classNames("countdown-wrapper")}>
          <span style={{ backgroundColor: color }}>{zeroPad(days)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(hours)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(minutes)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(seconds)}</span>
        </div>
      );
    }
  };

  goToRaffleDetail = () => {
    const { group_name } = this.props;
    this.props.history.push(`/kafair/raffle/${group_name}`);
  };

  render() {
    const { category } = this.state;
    const {
      isLogged,
      userData,
      title,
      isGolden,
      products,
      start_date,
      expiry_date,
      ticket_name,
      color,
      group_name,
      key,
      ticket_type,
      userRaffleTicket
    } = this.props;
    const userTicket =
      userRaffleTicket &&
      userRaffleTicket.data &&
      userRaffleTicket.data[ticket_type]
        ? userRaffleTicket.data[ticket_type].total
        : 0;

    const isStart = moment().isAfter(start_date);
    const isExpired = moment().isAfter(expiry_date);

    const sectionTitle = title ? title.toUpperCase().replace(/\+/gi, " ") : "";

    return (
      <Row
        className={classNames(
          `content-container raffle ${ticket_name.toLowerCase()}`
        )}
        style={{ borderColor: color, paddingTop: isLogged ? 65 : 10 }}
      >
        {isLogged && (
          <div className="ticket-wrapper">
            <KickImage
              src={
                userRaffleTicket.data &&
                userRaffleTicket.data[ticket_type] &&
                userRaffleTicket.data[ticket_type].ticket_signed_url
              }
            />
            <span>
              {`${ticket_name} Ticket`}: {userTicket}
            </span>
          </div>
        )}

        <Col md={3} xs={12}>
          <div className="left-side">
            <div className="timer-wrapper">
              <span>{isStart ? "Berakhir dalam" : "Mulai dalam"}</span>
              <Countdown
                date={
                  isStart
                    ? moment(expiry_date).toISOString()
                    : moment(start_date).toISOString()
                }
                daysInHours={true}
                zeroPadTime={2}
                renderer={this.renderTimer}
              />
            </div>
            <span className="title">
              {title ? title.replace(/\+/gi, " ") : ""}
            </span>
            <span className="title sub">
              Find out big discounted hype items here!
            </span>

            <div
              className={classNames("see-all-button")}
              style={{ backgroundColor: color }}
              onClick={this.goToRaffleDetail}
            >
              <span>JOIN RAFFLE</span>
            </div>
          </div>
        </Col>
        <Col md={9} xs={12}>
          <div className="right-side">{this.renderProducts()}</div>
          <div className="button-wrapper d-block d-sm-none">
            <div
              className={classNames("see-all-button")}
              style={{ backgroundColor: color }}
              onClick={this.goToRaffleDetail}
            >
              <span>JOIN RAFFLE</span>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  isLogged: state.dataAuth.isLogged,
  userData: state.dataAuth.userdata,
  data: state.dataKaFair.special_deals,
  userRaffleTicket: state.dataKaFair.userRaffleTicket
});

const mapDispatchToProps = dispatch => ({
  getCollectionList: (category, slug, payload, name) =>
    dispatch(getCollectionList(category, slug, payload, name)),
  getImageBanner: (slug, name) => dispatch(getImageBanner(slug, name))
});

export default connect(mapStateToProps, mapDispatchToProps)(RaffleSection);
